import React from "react";
import { ConflictTag } from "./conflictTag";
import difference from "lodash/difference";
import { ConflictTagType } from "shared/form/renderer/enums/Conflict";
import { useCopies } from "shared/hooks/useCopies";

export default function EmailListChangedValues(props: { values: Array<string>; conflictValues: Array<string> }) {
  const copies = useCopies();
  const { addedValues, removedValues } = React.useMemo(() => {
    const fieldValues = props.values.map((o: string) => o.toLowerCase());
    const fieldConflictValues = props.conflictValues.map((o: string) => o.toLowerCase());
    return {
      addedValues: difference(props.values, props.conflictValues),
      removedValues: difference(fieldConflictValues, fieldValues)
    };
  }, [props.conflictValues, props.values]);

  return (
    <React.Fragment>
      <strong className="emailListLabel hasError">{copies.get("conflict.changed.value")}</strong>
      <div className="emailListValues">
        {addedValues.map(o => {
          return (
            <span className="emailListValues--item" key={o}>
              {o}
              <ConflictTag conflictTagType={ConflictTagType.NEW_VALUE} />
            </span>
          );
        })}
        {removedValues.map(o => {
          return (
            <span className="emailListValues--item" key={o}>
              {o}
              <ConflictTag conflictTagType={ConflictTagType.DELETED_VALUE} />
            </span>
          );
        })}
      </div>
    </React.Fragment>
  );
}
